import React, { useCallback, Fragment, useState, useEffect } from "react";
import "./itemCardMobile.scss";
import placeholder from "../../common/assets/images/withoutitemimg.png";
import { useSelector } from "react-redux";
import { RootState } from "../../common/rootReducer";
import noteicon from "../../common/assets/svg/noteiconnew.svg";
// import { ReactComponent as Likeicon } from "../../common/assets/svg/likeiconnew.svg";
// import { ReactComponent as UnLikeicon } from "../../common/assets/svg/Eheart.svg";
import sendBtn from "../../common/assets/svg/sendBtn.svg";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import ItemDetails from "../../pages/menuDetails/index";

import {
  addCartItem,
  removeCartItem,
  startEmptyCart,
  startItemCustomisation,
  storeMenuItem,
  updateCartItem,
  incrementCartItem,
  decrementCartItem,
  saveOrderDetails,
} from "../../common/features/cart/cartActions";

import {
  getDecimalPlacedPriceString,
  getDefaultCustomisations,
} from "../../common/utils/menu-helper-utils";

import { startEmptyCartOrder } from "../../common/features/order/orderActions";
import { CartItem } from "../../common/features/cart/cartModels";
import { itemId } from "common/features/restaurant/restaurantAction";
interface ItemCardMobileProps {
  data: any;
  setCustomisationItemId: any;
  isRestaurantOpen?: number;
  GridView?: any;
}

const ItemCardMobile: React.FC<ItemCardMobileProps> = (props) => {
  const dispatch = useDispatch();
  const [isFav, setIsfav] = useState(false);

  const restaurantCountry = useSelector(
    (state: any) => state?.restaurant?.currentResCountry
  );

  const itemIndividualCustomizationEnabled = useSelector((state: any) =>
    state.cart.customisedIndividualItems.includes(props.data.itemId)
  );

  const cartData = useSelector((state: any) => {
    return state.cart.cart.items.find((item: any) => {
      if (item.itemId == props.data.itemId) {
      }
      return item.itemId == props.data.itemId;
    });
  });

  const locationID = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail.id
  );

  const restaurantDetails = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
  );

  const [activeTooltip, setActiveTooltip] = useState<number | null>(null);

  const handleTooltipToggle = (index: number) => {
    setActiveTooltip(activeTooltip === index ? null : index);
  };

  const cartDataIndex = useSelector((state: any) => {
    return state?.cart?.cart?.items.findIndex((item: any) => {
      if (item.itemId == props?.data?.itemId) {
        // console.log('cartData - ', item);
      }
      return item.itemId == props?.data?.itemId;
    });
  });

  function getCartPrice(price: number) {
    if (restaurantCountry?.length > 0) {
      if (restaurantCountry == "US") {
        return getDecimalPlacedPriceString(price);
      } else {
        return getDecimalPlacedPriceString(price);
      }
    } else {
      return price;
    }
  }

  const cartMenuDefaultTax = useSelector(
    (state: any) => state.cart.cartMenuDefaultTax
  );

  const getItemPrice = useCallback(
    (type?: string) => {
      let price =
        cartData && cartData.price && Number(cartData.price)
          ? Number(cartData.price)
          : props.data.price && Number(props.data.price)
          ? Number(props.data.price)
          : 0;

      const quantity =
        cartData && Number(cartData.quantity) ? Number(cartData.quantity) : 1;
      switch (type) {
        case "discount":
          if (cartData?.options.length === 0) {
            price =
              cartData && cartData.subTotal && Number(cartData.subTotal)
                ? Number(cartData.subTotal)
                : price * quantity;
          } else {
            price =
              cartData && cartData.offer_amount && Number(cartData.offer_amount)
                ? Number(cartData.offer_amount)
                : price * quantity;
          }
          break;
        case "totalPrice":
          price = price * quantity;
          break;
        default:
          break;
      }
      if (restaurantCountry.length > 0) {
        if (restaurantCountry == "US") {
          return getDecimalPlacedPriceString(price);
        } else {
          return getDecimalPlacedPriceString(price);
        }
      } else {
        return String(price);
      }
    },
    [restaurantCountry, props]
  );

  const getItemTax = useCallback(() => {
    return props.data.isDefaultItemTax && cartMenuDefaultTax
      ? cartMenuDefaultTax
      : props.data.tax || [];
  }, [props, cartMenuDefaultTax]);

  const get12HoursTime = (t24Stamp: string, nextAvailableDay: string) => {
    let timeString = t24Stamp?.split("T")[1];
    if (timeString == "00:00:00") {
      return "Will be available tomorrow";
    } else {
      let hours = timeString?.split(":")[0];
      let mins = timeString?.split(":")[1];
      let median = "";
      if (parseInt(hours) >= 12) {
        hours = parseInt(hours) - 12 + "";
        median = "PM";
      } else {
        median = "AM";
      }
      return (
        "Will be available on " +
        nextAvailableDay +
        " " +
        [hours, ":", mins, median]?.join(" ") +
        ""
      );
    }
  };

  const cartItems = useSelector((state: any) => state.cart.cart.items);

  const individualCustomisedItemCount = useSelector(
    (state: any) =>
      state.cart.cart.items.filter((item: any) => {
        return item.itemId == props.data.itemId;
      }).length
  );

  const lastIndividualItemIndex = useSelector((state: any) =>
    state.cart.cart.items
      .map((item: any) => item.itemId)
      .lastIndexOf(props.data.itemId)
  );

  const isOutOfStock =
    (props?.data?.stockQuantity !== null &&
      Number(props?.data?.stockQuantity) < 1) ||
    props?.data?.isCategoryOff == true;

  const isTemporarilyUnavailable =
    new Date(props.data.itemUnAvailableUntil).getFullYear() > 3000;

  const isUnAvailableUntil =
    new Date(props?.data?.itemUnAvailableUntil)?.getFullYear() < 3000 &&
    get12HoursTime(
      props?.data?.itemUnAvailableUntil,
      props?.data?.nextAvailableDay != null ? props?.data?.nextAvailableDay : ""
    );

  const addItem = useCallback(() => {
    const quantity =
      cartData && Number(cartData.quantity) ? Number(cartData.quantity) : 0;
    if (quantity > 0 && !itemIndividualCustomizationEnabled) {
      // if (quantity == 10) {
      //   dispatch(showItemMaxCountPrompt());
      // } else {
      const price: number =
        props.data.price && Number(props.data.price)
          ? Number(props.data.price) * (quantity + 1)
          : 0;
      dispatch(
        updateCartItem(
          props.data.itemId,
          String(getCartPrice(price)),
          false,
          quantity + 1
        )
      );
      // }
    } else if (quantity == 0) {
      dispatch(
        addCartItem({
          itemId: props.data.itemId,
          itemName: props.data.itemName,
          itemAltName: props.data.itemAltName ? props.data.itemAltName : "",
          price: props?.data?.offerPrice
            ? String(props?.data?.offerPrice)
            : props.data.price,
          quantity: "1",
          subTotal: getItemPrice("discount"),
          comment: "",
          is_discount_applied: false,
          options: [],
          tax: getItemTax(),
          offer_data: null,
          offer_amount: Number(getItemPrice("discount")),
          availability: props.data.availability,
          stockQuantity: props.data.stockQuantity,
          alertQuantity: props.data.alertQuantity,
        })
      );
    }
  }, [props]);

  const removeItem = useCallback(() => {
    const quantity =
      cartData && Number(cartData.quantity) ? Number(cartData.quantity) : 0;
    // if (itemCount > 1) {
    //   itemCustomized
    //     ? dispatch(decrementCartItem(props.itemDetail.itemId))
    //     : dispatch(decrementCartItem(props.itemDetail.itemId));
    // } else if (itemCount == 1) {
    //   dispatch(removeCartItem(props.itemDetail.itemId));
    // }
    if (itemIndividualCustomizationEnabled) {
      if (individualCustomisedItemCount == 1) {
        dispatch(removeCartItem(props.data.itemId));
      } else {
        dispatch(removeCartItem(props.data.itemId, lastIndividualItemIndex));
      }
    } else {
      if (quantity == 1) {
        dispatch(removeCartItem(props.data.itemId));
      } else {
        const price: number =
          props.data.price && Number(props.data.price)
            ? Number(props.data.price) * (quantity - 1)
            : 0;
        dispatch(
          updateCartItem(
            props.data.itemId,
            String(getCartPrice(price)),
            false,
            quantity - 1
          )
        );
        // dispatch(decrementCartItem(props.itemDetail.itemId));
      }
    }
  }, [props]);

  const history = useHistory();
  const hasCustomization = useCallback(() => {
    return (
      props.data.customization &&
      props.data.customization.length > 0 &&
      props.data.customization?.filter((item: any) => item.typeAvailable === 1)
        .length > 0
    );
  }, [props]);

  const getMenuItemImageUrl = useCallback(
    (imgId: string | null, ext: string | null) => {
      return process.env.REACT_APP_IMAGE_URL + "img" + "/" + imgId + "." + ext;
    },
    []
  );

  const submitOrderNote = (note: string) => {
    // dispatch(specialNotes(props.data.itemId, cartDataIndex, true, note));
  };

  const removeOrderNotes = () => {
    // dispatch(removeNotes(props.data.itemId, cartDataIndex, true));
  };

  const [customizationPopup, setCustomizationPopup] = useState(false);
  const [noncustomization, setNoncustomization] = useState(false);
  const [showOrderNote, setShowOrderNote] = useState(false);
  const customerId = localStorage.getItem("USER_ID");
  const visibleIngredients = props?.data?.ingredient?.slice(0, 2);
  const remainingIngredients =
    props?.data?.ingredient?.length - visibleIngredients?.length;

  const orderNoteItem = useSelector((state: any) => state.cart.cart.items);
  const comment = orderNoteItem?.find(
    (item: any) => props.data?.itemId === item?.itemId
  )?.comment;

  const increment = (index: any) => {
    dispatch(incrementCartItem(props.data.itemId, index, false));
  };

  const decrement = (index: any) => {
    const quantity =
      cartData && Number(cartData.quantity) ? Number(cartData.quantity) : 0;

    if (quantity > 1) {
      dispatch(decrementCartItem(props.data.itemId, index, false));
    } else {
      dispatch(removeCartItem(props.data.itemId, index, false));
    }
  };

  const handleAddItem = (type: any) => {};
  const AddRemoveFav = (e: any, id: any, value: any) => {};

  const handleQuantityChange = (quantity: number) => {
    // console.log("New quantity:", quantity);
  };

  const handleNavigation = (e: any) => {
    e.stopPropagation();
    dispatch(itemId(props.data.itemId));
    history.push("/itemDetails");
  };

  const ItemWithImage = () => {
    return (
      <div
        className={
          new Date(props.data.itemUnAvailableUntil).getFullYear() > 3000
            ? "ItemCardMobile-container-unavailable"
            : "ItemCardMobile-container"
        }
        onClick={(e) => {
          e.stopPropagation();
          dispatch(itemId(props.data.itemId));
          history.push("/itemDetails");
        }}
      >
        <div className="ItemCardMobile">
          <p className="itemName-mobile-new">{props.data.itemName}</p>

          <p className="itemprice-mobile-new">
            {restaurantCountry == "US" ? (
              <Fragment>&#36;&nbsp;</Fragment>
            ) : restaurantCountry == "IN" ? (
              <Fragment> &#x20B9;&nbsp;</Fragment>
            ) : null}
            {props.data.price}
          </p>

          {props.data.description && (
            <p className="itemdescription-mobile-new" dangerouslySetInnerHTML={{ __html: props.data.description }}/>
          )}

          <div className="food-ingrdients-container">
            {visibleIngredients?.map(
              (ingredient: any, index: number) =>
                ingredient?.name &&
                ingredient?.type &&
                ingredient?.img && (
                  <span key={index} className="ingredients-image-container-new">
                    {ingredient?.type && ingredient?.img && (
                      <>
                        <span
                          className="ingredients-image-new"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleTooltipToggle(index);
                          }}
                        >
                          <img
                            src={getMenuItemImageUrl(
                              ingredient?.img,
                              ingredient?.type.split("/")[1]
                            )}
                            alt=""
                          />
                          {activeTooltip === index && (
                            <div className="tooltip">{ingredient?.name}</div>
                          )}{" "}
                        </span>
                      </>
                    )}
                  </span>
                )
            )}

            {remainingIngredients > 0 && (
              <div className="remainingIngredirnts-mobile-new">
                +{remainingIngredients}
              </div>
            )}
          </div>
        </div>

        {!isOutOfStock &&
          !isTemporarilyUnavailable &&
          !(
            !props?.data?.enable &&
            props?.data?.itemUnAvailableUntil &&
            !isTemporarilyUnavailable
          ) &&
          hasCustomization() && (
            <div className="Customizable-withimage">
              <span>Customizable</span>
            </div>
          )}

        <div className="ItemCardMobile-image-Addbtn">
          {props?.data?.itemImage && props?.data?.itemType && (
            <img
              src={
                getMenuItemImageUrl(
                  props?.data?.itemImage ?? null,
                  props?.data?.itemType?.split("/")[1] ?? null
                ) || ""
              }
              alt=""
              className={
                isOutOfStock ||
                isTemporarilyUnavailable ||
                (!isTemporarilyUnavailable &&
                  !props.data.enable &&
                  props.data.itemUnAvailableUntil)
                  ? "itemImage-mobile-outOfStock"
                  : "itemImage-mobile"
              }
            />
          )}

          {isOutOfStock ? (
            <p className="availability-message">Out of Stock</p>
          ) : isTemporarilyUnavailable ? (
            <p className="availability-message">Temporarily Unavailable</p>
          ) : !props.data.enable &&
            props.data.itemUnAvailableUntil &&
            !isTemporarilyUnavailable ? (
            <div className="availabilityUntil-message">
              {isUnAvailableUntil}
            </div>
          ) : null}

          <button
            className="Add-btn-new"
            onClick={(e) => {
              handleNavigation(e)
            }}
          >
            {(cartData && Number(cartData.quantity)
              ? Number(cartData.quantity)
              : 0) > 0 ? (
              <div className="quantity-control-noncustomization-new-withimage">
                <button
                  className="quantity-button-noncustomization-withimage minus"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddItem("minus");
                  }}
                >
                  −
                </button>
                {/* cartData && Number(cartData.quantity) ? Number(cartData.quantity) : 1 */}
                <span className="quantity">
                  {cartData &&
                    Number(cartData.quantity) &&
                    Number(cartData.quantity).toString().padStart(2, "0")}
                </span>

                <button
                  className="quantity-button-noncustomization-withimage plus"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddItem("plus");
                  }}
                >
                  +
                </button>
              </div>
            ) : (
              <span>View</span>
            )}
          </button>
        </div>
      </div>
    );
  };

  const ItemWithoutImage = () => {
    return (
      <div
        className="ItemCardMobile-container-withoutImage"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(itemId(props?.data?.itemId));
          history.push("/itemDetails");
        }}
      >
        <div
          className={
            new Date(props.data.itemUnAvailableUntil).getFullYear() > 3000
              ? "ItemCardMobile-withoutImage-unavailable"
              : "ItemCardMobile-withoutImage"
          }
        >
          <p className="itemName-mobile-new-withoutImage">
            {props?.data?.itemName}
          </p>
          <p className="itemprice-mobile-new-withoutImage">
            {restaurantCountry == "US" ? (
              <Fragment>&#36;&nbsp;</Fragment>
            ) : restaurantCountry == "IN" ? (
              <Fragment> &#x20B9;&nbsp;</Fragment>
            ) : null}
            {props?.data?.price}
          </p>

          {props?.data?.description && (
            <p
              className={
                isOutOfStock ||
                isTemporarilyUnavailable ||
                (!isTemporarilyUnavailable &&
                  !props.data.enable &&
                  props.data.itemUnAvailableUntil)
                  ? "itemdescription-mobile-new-withoutImage1"
                  : "itemdescription-mobile-new-withoutImage"
              }
            dangerouslySetInnerHTML={{ __html: props?.data?.description }}
            />
          )}

          <div className="food-ingrdients-container">
            {visibleIngredients?.map((ingredient: any, index: number) =>
              ingredient?.name && ingredient?.type && ingredient?.img ? (
                <span key={index} className="ingredients-image-container-new">
                  {ingredient?.type && ingredient?.img && (
                    <>
                      <span
                        className="ingredients-image-new"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleTooltipToggle(index);
                        }}
                      >
                        <img
                          src={getMenuItemImageUrl(
                            ingredient?.img,
                            ingredient?.type.split("/")[1]
                          )}
                          alt={ingredient?.name}
                          className="ingredient-image"
                        />
                        {activeTooltip === index && (
                          <div className="tooltip">{ingredient?.name}</div>
                        )}
                      </span>
                    </>
                  )}
                </span>
              ) : null
            )}

            {remainingIngredients > 0 && (
              <div className="remainingIngredirnts-mobile-new">
                +{remainingIngredients}
              </div>
            )}
          </div>
        </div>

        {!isOutOfStock &&
          !isTemporarilyUnavailable &&
          (props?.data?.enable || !props?.data?.itemUnAvailableUntil) &&
          hasCustomization() && (
            <div className="Customizable-withoutimage">
              <span>Customizable</span>
            </div>
          )}

        {!props.data.enable &&
        props.data.itemUnAvailableUntil &&
        isTemporarilyUnavailable ? (
          <div className="availablity-message-withoutImage-temp">
            Temporarily Unavailable
          </div>
        ) : !props.data.enable &&
          props.data.itemUnAvailableUntil &&
          !isTemporarilyUnavailable ? (
          <div className="until-availablity-message-withoutImage">
            {isUnAvailableUntil}
          </div>
        ) : isOutOfStock ? (
          <div className="availablity-message-withoutImage">Out Of Stock</div>
        ) : null}

        <div className="ItemCardMobile-image-Addbtn-withoutImage">
          <div
            className="Add-btn-new"
            onClick={(e) => {handleNavigation(e)}}
          >
            {(cartData && Number(cartData?.quantity)
              ? Number(cartData?.quantity)
              : 0) > 0 ? (
              <div className="quantity-control-noncustomization-new">
                <button
                  className="quantity-button-noncustomization minus"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddItem("minus");
                  }}
                >
                  −
                </button>

                <span className="quantity">
                  {cartData &&
                    Number(cartData?.quantity) &&
                    Number(cartData?.quantity).toString().padStart(2, "0")}
                </span>

                <button
                  className="quantity-button-noncustomization plus"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddItem("plus");
                  }}
                >
                  +
                </button>
              </div>
            ) : (
              <span>View</span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const ItemCardGrid = () => {
    return (
      <div className="GridItemCard" onClick={(e) => {handleNavigation(e)}}>
        {
          props?.data?.itemImage && props?.data?.itemType ? (
            <img
              src={
                getMenuItemImageUrl(
                  props?.data?.itemImage ?? null,
                  props?.data?.itemType?.split("/")[1] ?? null
                ) || ""
              }
              alt=""
              style={{
                opacity:
                  isOutOfStock ||
                  (!props.data.enable &&
                    props.data.itemUnAvailableUntil &&
                    !isTemporarilyUnavailable) ||
                  (!props.data.enable &&
                    props.data.itemUnAvailableUntil &&
                    isTemporarilyUnavailable)
                    ? "50%"
                    : "100%",
              }}
              className="itemImage-grid"
            />
          ) : (
            <img
              src={placeholder}
              alt=""
              className="placeholderimg-grid"
              style={{
                opacity:
                  isOutOfStock ||
                  (!props.data.enable &&
                    props.data.itemUnAvailableUntil &&
                    !isTemporarilyUnavailable) ||
                  (!props.data.enable &&
                    props.data.itemUnAvailableUntil &&
                    isTemporarilyUnavailable)
                    ? "50%"
                    : "100%",
              }}
            />
          )
          // <img  src={placeholder} alt="" className='itemImage-mobile-placeholder' />
        }

        {!isOutOfStock &&
          !isTemporarilyUnavailable &&
          (props?.data?.enable || !props?.data?.itemUnAvailableUntil) &&
          hasCustomization() && (
            <div className="Customizabletag-grid">
              <span>Customizable</span>
            </div>
          )}

        <div className="GridView-itemDetails-container">
          <div className="GridView-itemDetails-content">
            <p className="itemName-mobile-new-grid">{props?.data?.itemName}</p>

            <p className="itemprice-mobile-new-grid">
              {restaurantCountry == "US" ? (
                <Fragment>&#36;&nbsp;</Fragment>
              ) : restaurantCountry == "IN" ? (
                <Fragment> &#x20B9;&nbsp;</Fragment>
              ) : null}
              {props?.data?.price}
            </p>

            {
              <p className="itemdescription-mobile-new-grid" dangerouslySetInnerHTML={{ __html: props?.data?.description}}/>

            }

            <div className="food-ingrdients-container">
              {visibleIngredients?.map(
                (ingredient: any, index: number) =>
                  ingredient?.name &&
                  ingredient?.type &&
                  ingredient?.img && (
                    <span
                      key={index}
                      className="ingredients-image-container-new"
                    >
                      {ingredient?.type && ingredient?.img && (
                        <>
                          <span
                            className="ingredients-image-new"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleTooltipToggle(index);
                            }}
                          >
                            <img
                              src={getMenuItemImageUrl(
                                ingredient?.img,
                                ingredient?.type.split("/")[1]
                              )}
                              alt=""
                            />
                            {activeTooltip === index && (
                              <div className="tooltip">{ingredient?.name}</div>
                            )}{" "}
                          </span>
                        </>
                      )}
                    </span>
                  )
              )}

              {remainingIngredients > 0 && (
                <div className="remainingIngredirnts-mobile-new">
                  +{remainingIngredients}
                </div>
              )}
            </div>
          </div>
          <div className="ItemCardMobile-image-Addbtn-grid">
            <div
              className={
                (cartData && Number(cartData?.quantity)
                  ? Number(cartData?.quantity)
                  : 0) > 0
                  ? "Add-btn-new-grid-Spinner"
                  : "Add-btn-new-grid"
              }
              onClick={(e) => {handleNavigation(e)}}
            >
              {(cartData && Number(cartData?.quantity)
                ? Number(cartData?.quantity)
                : 0) > 0 ? (
                <div className="quantity-control-noncustomization-new-grid">
                  <button
                    className="quantity-button-noncustomizationgrid minus"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddItem("minus");
                    }}
                  >
                    −
                  </button>

                  <span className="quantity-grid">
                    {cartData &&
                      Number(cartData?.quantity) &&
                      Number(cartData?.quantity).toString().padStart(2, "0")}
                  </span>

                  <button
                    className="quantity-button-noncustomizationgrid plus"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddItem("plus");
                    }}
                  >
                    +
                  </button>
                </div>
              ) : (
                <span>View</span>
              )}
            </div>
          </div>
        </div>

        {!props.data.enable &&
        props.data.itemUnAvailableUntil &&
        isTemporarilyUnavailable ? (
          <div className="availablity-message-grid-temp">
            Temporarily Unavailable
          </div>
        ) : !props.data.enable &&
          props.data.itemUnAvailableUntil &&
          !isTemporarilyUnavailable ? (
          <div className="until-availablity-message-grid">
            {isUnAvailableUntil}
          </div>
        ) : isOutOfStock ? (
          <div className="availablity-message-grid">Out Of Stock</div>
        ) : null}
      </div>
    );
  };

  return (
    <>
      {restaurantDetails?.theme?.viewType === "GRID" ? (
        <>
          <ItemCardGrid />
        </>
      ) : (
        <>
          {props.data?.itemImage && props.data?.itemType ? (
            <ItemWithImage />
          ) : (
            <ItemWithoutImage />
          )}
        </>
      )}
    </>
  );
};

export default ItemCardMobile;
